import React, { useCallback, useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

export interface IToggleProps extends Omit<React.HTMLAttributes<HTMLButtonElement>, 'checked'|'onChange'|'onClick'> {
    checked?: boolean;
    onChange?: (newValue: boolean) => void;
}

const useStyles = createUseStyles<string, {checked: boolean}>({
    toggle: {
        borderRadius: 20,
        border: '2px solid darkgrey',
        background: data => data.checked ? 'green' : 'grey',
        position: 'relative',
        height: 44,
        width: 80,
        '&::after': {
            position: 'absolute',
            content: '""',
            display: 'block',
            top: 0,
            bottom: 0,
            aspectRatio: 1,
            borderRadius: 20,
            height: '100%',
            background: 'white',
        },
        '&[aria-checked=true]::after': {
            right: 0,
        },
        '&[aria-checked=false]::after': {
            left: 0,
        },
    },
});

export const Toggle: React.FunctionComponent<IToggleProps> = props => {
    const { checked, onChange, ...nativeProps } = props;
    const [ state, setState ] = useState<boolean>(checked ?? false);
    useEffect(() => {
        setState(checked ?? false);
    }, [ checked ]);

    const handleChange = useCallback(() => {
        setState(current => {
            const next = !current;
            onChange?.(next);
            return next;
        });
    }, [ onChange ]);

    const styles = useStyles({ checked: state });

    return (
        <button
            {...nativeProps}
            className={clsx(styles.toggle, nativeProps.className)}
            onClick={handleChange}
            role="switch"
            aria-checked={state}
        ></button>
    );

};
